import { Modal, message, Radio, Button } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { putRequest } from "../../service";
import { getChangedFields } from "../../utils/getChangedFields";

const EligibilityEdit = (props) => {
  const { open, onRequestClose, employee } = props;
  const [form, setForm] = useState({
    medical: "",
    travel: "",
    bouns: ""
  });
  const originalFormRef = useRef({});

  useEffect(() => {
    if (employee) {
      const initialData = {
        medical: employee.medical || "",
        travel: employee.travel || "",
        bouns: employee.bouns || ""
      };
      setForm(initialData);
      originalFormRef.current = initialData;
    }
  }, [employee]);

  const handleChange = (name, e) => {
    setForm(prev => ({
      ...prev,
      [name]: e.target.value
    }));
  };

  const handleSubmit = async () => {
    try {
      const payload = getChangedFields(originalFormRef.current, form);
      if (Object.keys(payload).length === 0) {
        message.info("No changes to update");
        return;
      }
      const response = await putRequest(`/api/employees?employeeId=${employee._id}`, payload);
      if (response.message === 'Employee updated successfully (some related data could not be loaded)') {
        message.success('Employee updated successfully')
        onRequestClose();
      }
      else {
        message.error(response.message || "Employee not updated")
      }
    } catch (error) {
      console.error('Error updating employee:', error);
    }
  };

  return (
    <Modal
      title="Eligibility Information"
      open={open}
      onCancel={onRequestClose}
      footer={null}
      width={800}
    >
      <div className="flex items-start justify-between bg-white h-[50vh] overflow-auto">
        <div className="bg-form-bg w-full rounded-md px-4 py-8">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
              <h4 className="text-md font-normal">Medical Insurance</h4>
              <Radio.Group
                options={[
                  { label: "Eligible", value: "eligible" },
                  { label: "Not Eligible", value: "noteligible" },
                ]}
                onChange={(e) => handleChange("medical", e)}
                value={form.medical}
              />
            </div>
            <div className="flex flex-col gap-2">
              <h4 className="text-md">Travel</h4>
              <Radio.Group
                options={[
                  { label: "Eligible", value: "eligible" },
                  { label: "Not Eligible", value: "noteligible" },
                ]}
                onChange={(e) => handleChange("travel", e)}
                value={form.travel}
              />
            </div>
            <div className="flex flex-col gap-2">
              <h4 className="text-md">Bonus</h4>
              <Radio.Group
                options={[
                  { label: "Eligible", value: "eligible" },
                  { label: "Not Eligible", value: "noteligible" },
                ]}
                onChange={(e) => handleChange("bouns", e)}
                value={form.bouns}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end gap-3 my-2">
        <Button onClick={onRequestClose} >Cancel</Button>
        <Button
          onClick={handleSubmit}
          type="primary"
          className="bg-primary text-white"
        >
          Update Eligibility
        </Button>
      </div>
    </Modal>
  );
};

export default EligibilityEdit;
